import { render, staticRenderFns } from "./InviteConfirm.vue?vue&type=template&id=c28a329e&"
import script from "./InviteConfirm.vue?vue&type=script&lang=js&"
export * from "./InviteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports